const ACCOUNT_OWNER_ROLE = 'AccountOwner';
const PURCHASER_ROLE = 'Purchaser';
const SECONDARY_OWNER_ROLE = 'SecondaryOwner';
const SUPPORT_ROLE = 'Support';
const TECHNICIAN_ROLE = 'Technician';

export type Role =
	| typeof ACCOUNT_OWNER_ROLE
	| typeof PURCHASER_ROLE
	| typeof SECONDARY_OWNER_ROLE
	| typeof SUPPORT_ROLE
	| typeof TECHNICIAN_ROLE;

export const ROLES: Role[] = [
	ACCOUNT_OWNER_ROLE,
	PURCHASER_ROLE,
	SECONDARY_OWNER_ROLE,
	SUPPORT_ROLE,
	TECHNICIAN_ROLE,
] as const;

export const isRoleType = (role: string) => {
	return ROLES.some((roleType) => roleType === role);
};

export type SelectableRole =
	| typeof SECONDARY_OWNER_ROLE
	| typeof PURCHASER_ROLE
	| typeof TECHNICIAN_ROLE;

export const SELECTABLE_ROLES: SelectableRole[] = [
	SECONDARY_OWNER_ROLE,
	PURCHASER_ROLE,
	TECHNICIAN_ROLE,
] as const;

export const isSelectableRoleType = (role: string) => {
	return SELECTABLE_ROLES.some(
		(selectableRoleType) => selectableRoleType === role,
	);
};

export type RoleFilterOption = 'All' | Role;

export const roleDisplay = (role: Role) => {
	switch (role) {
		case 'AccountOwner':
			return 'Account Owner';
		case 'SecondaryOwner':
			return 'Secondary Owner';
		default:
			return role;
	}
};

const ACTIVE_STATUS = 'Active';
const INACTIVE_STATUS = 'Inactive';

export const STATUSES = [ACTIVE_STATUS, INACTIVE_STATUS] as const;

export type Status = (typeof STATUSES)[number];

export type StatusFilterOption = 'All' | Status;

const TWO_FACTOR_ENABLED = 'Enabled';
const TWO_FACTOR_DISABLED = 'Disabled';

export const TWO_FACTOR_STATUSES = [
	TWO_FACTOR_ENABLED,
	TWO_FACTOR_DISABLED,
] as const;

export type TwoFactorStatus = (typeof TWO_FACTOR_STATUSES)[number];

export type TwoFactorStatusFilterOption = 'All' | TwoFactorStatus;
